import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { SiteHeader } from '@/components/site-header'
import { DownloadForm } from '@/components/downloads/download-form'
import { FUTURE_OF_MEDIA_2026_CONTENT } from '@/content/downloads/future-of-media-2026'

export default function FutureOfMedia2026Page() {
  // Set metadata and noindex
  useEffect(() => {
    document.title = FUTURE_OF_MEDIA_2026_CONTENT.pageTitle

    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]')
    if (!metaDescription) {
      metaDescription = document.createElement('meta')
      metaDescription.setAttribute('name', 'description')
      document.head.appendChild(metaDescription)
    }
    metaDescription.setAttribute('content', FUTURE_OF_MEDIA_2026_CONTENT.pageDescription)

    // Add noindex meta tag
    let metaRobots = document.querySelector('meta[name="robots"]')
    if (!metaRobots) {
      metaRobots = document.createElement('meta')
      metaRobots.setAttribute('name', 'robots')
      document.head.appendChild(metaRobots)
    }
    metaRobots.setAttribute('content', 'noindex, nofollow')

    // Cleanup on unmount
    return () => {
      if (metaRobots && metaRobots.parentNode) {
        metaRobots.parentNode.removeChild(metaRobots)
      }
    }
  }, [])

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <section className="relative py-16 md:py-24">
          <div className="container">
            <div className="mx-auto max-w-2xl">
              {/* Header */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="mb-12 text-center"
              >
                <p className="mb-3 text-sm font-medium uppercase tracking-wider text-muted-foreground">
                  {FUTURE_OF_MEDIA_2026_CONTENT.eyebrow}
                </p>
                <h1 className="mb-4 text-3xl font-bold md:text-4xl">
                  {FUTURE_OF_MEDIA_2026_CONTENT.headerTitle}
                </h1>
                <p className="text-lg text-muted-foreground">
                  {FUTURE_OF_MEDIA_2026_CONTENT.headerSubtitle}
                </p>
              </motion.div>

              {/* Form Card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="rounded-lg border border-border bg-card p-6 shadow-lg md:p-8"
              >
                <DownloadForm
                  content={FUTURE_OF_MEDIA_2026_CONTENT}
                  downloadType="future-of-media-2026"
                />
              </motion.div>
            </div>
          </div>
        </section>
      </main>
    </div>
  )
}
